import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=18f83e18&scoped=true"
import script from "./Transfer.vue?vue&type=script&lang=js"
export * from "./Transfer.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Transfer.vue?vue&type=style&index=1&id=18f83e18&prod&scoped=true&lang=css"
import style2 from "./Transfer.vue?vue&type=style&index=2&id=18f83e18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f83e18",
  null
  
)

export default component.exports